import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import EnhanceSizeGuide from "./EnhanceSizeGuide";
import ResizedImage from "theme/components/atoms/ResizedImage";
import { ButtonLink } from "theme/components/atoms/Typography/Link";
import { makeAbsoluteUrl } from "theme/modules/Core";

const ModalContentWysiwyg = ({
  content,
  media,
  link_label,
  description,
  title,
}) => (
  <div className="size-guide__modal__wysiwyg wysiwyg">
    {title && <span className="size-guide__modal__title">{title}</span>}
    {description && (
      <span className="size-guide__modal__description">{description}</span>
    )}
    {media && (
      <ResizedImage src={media.link} srcset={media.srcset} alt={media.title} />
    )}
    {link_label && content?.link && (
      <div className="size-guide__modal__btn-action">
        <ButtonLink
          to={makeAbsoluteUrl(content.link)}
          buttonAppearance="default"
        >
          {link_label}
        </ButtonLink>
      </div>
    )}
  </div>
);

const SizesTab = ({ lines }) => (
  <tbody>
    {lines.map((line, index) => (
      <tr className="size-guide__tab__line" key={index}>
        {line.split("||").map((column, columnIndex) => (
          <th className="size-guide__tab__column" key={columnIndex}>
            {column}
          </th>
        ))}
      </tr>
    ))}
  </tbody>
);

const ModalContent = ({
  sizeGuide,
  attributeSetLabel,
  media,
  link_label,
  description,
  title,
}) => {
  const renderTitle = () => {
    if (attributeSetLabel === "Chaussons") {
      return (
        <>
          <FormattedMessage
            id="components.organism.SizeGuide.title"
            defaultMessage="These slippers fit small."
          />
          <br />
          <FormattedMessage
            id="components.organism.SizeGuide.title2"
            defaultMessage="We recommend choosing one size up."
          />
        </>
      );
    }
    return (
      <FormattedMessage
        id="components.organism.SizeGuide.title-default"
        defaultMessage="Sizes guide"
      />
    );
  };

  return (
    <Fragment>
      <span className="modal__title">{renderTitle()}</span>
      <div className="size-guide__modal__content">
        <div className="size-guide__tab">
          <table>
            {sizeGuide?.sizes && <SizesTab lines={sizeGuide.sizes} />}
          </table>
        </div>
        {sizeGuide?.content?.title && (
          <ModalContentWysiwyg
            content={sizeGuide.content}
            media={media}
            link_label={link_label}
            description={description}
            title={title}
          />
        )}
      </div>
    </Fragment>
  );
};

export default EnhanceSizeGuide()(ModalContent);
